module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "menu"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/en"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/england.jpg")
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/cat"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/catalan.png")
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "router-link": "",
      "to": "/es"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/spain.png")
    }
  })])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eda8ad1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fr/LanguageMenu.vue
// module id = 131
// module chunks = 0